const books = [
    {
        alias: "canadareads",
        navigation: [
            {
                link: "/books/canadareads/about-1.4025711",
                title: "About",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/listen/shows/canada-reads",
                title: "Listen",
                type: "external",
            },
            {
                link: "https://gem.cbc.ca/canada-reads",
                title: "Watch",
                type: "external",
            },
            {
                link: "/books/canadareads/past-canada-reads-winners-1.4034451",
                title: "Past Winners",
                type: "internal",
            },
            {
                link: "/books/canadareads/transcripts",
                title: "Transcripts",
                type: "internal",
            },
        ],
    },
];

export default books;
